import { render, staticRenderFns } from "./change-password.vue?vue&type=template&id=4cc0b733"
import script from "./change-password.vue?vue&type=script&lang=js"
export * from "./change-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports